import styled from "styled-components";

export const SmsVerificationStyled = styled.div`
  width: 100%;
  padding: 0px 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .verification_container {
    width: 100%;
  }

  .logo_text {
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
  }

  .desc_text {
    color: #666;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;
